// tslint:disable
/**
 * dbo-print-forms
 * MTS Bank / MTS IT
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url'
import { Configuration } from './configuration'
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base'

/**
 *
 * @export
 * @interface AccountDetailsReq
 */
export interface AccountDetailsReq {
  /**
   *
   * @type {number}
   * @memberof AccountDetailsReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof AccountDetailsReq
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof AccountDetailsReq
   */
  number: string
  /**
   *
   * @type {string}
   * @memberof AccountDetailsReq
   */
  email: string
}
/**
 *
 * @export
 * @interface AccountDetailsRes
 */
export interface AccountDetailsRes {
  /**
   *
   * @type {string}
   * @memberof AccountDetailsRes
   */
  requestId?: string
}
/**
 *
 * @export
 * @interface AccountReferenceReq
 */
export interface AccountReferenceReq {
  /**
   *
   * @type {string}
   * @memberof AccountReferenceReq
   */
  lang: string
  /**
   *
   * @type {number}
   * @memberof AccountReferenceReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof AccountReferenceReq
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof AccountReferenceReq
   */
  number: string
  /**
   *
   * @type {string}
   * @memberof AccountReferenceReq
   */
  email?: string
}
/**
 *
 * @export
 * @interface AccountReferenceRes
 */
export interface AccountReferenceRes {
  /**
   *
   * @type {string}
   * @memberof AccountReferenceRes
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof AccountReferenceRes
   */
  file?: string
}
/**
 *
 * @export
 * @interface AccountStatementReq
 */
export interface AccountStatementReq {
  /**
   *
   * @type {string}
   * @memberof AccountStatementReq
   */
  endDt: string
  /**
   *
   * @type {string}
   * @memberof AccountStatementReq
   */
  number: string
  /**
   *
   * @type {number}
   * @memberof AccountStatementReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof AccountStatementReq
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof AccountStatementReq
   */
  startDt: string
  /**
   *
   * @type {string}
   * @memberof AccountStatementReq
   */
  email?: string
}
/**
 *
 * @export
 * @interface AccountStatementRes
 */
export interface AccountStatementRes {
  /**
   *
   * @type {string}
   * @memberof AccountStatementRes
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof AccountStatementRes
   */
  file?: string
}
/**
 *
 * @export
 * @interface BaseResponse
 */
export interface BaseResponse {
  /**
   *
   * @type {string}
   * @memberof BaseResponse
   */
  requestId?: string
}
/**
 *
 * @export
 * @interface CardDetailsReq
 */
export interface CardDetailsReq {
  /**
   *
   * @type {number}
   * @memberof CardDetailsReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof CardDetailsReq
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof CardDetailsReq
   */
  hashPAN: string
  /**
   *
   * @type {string}
   * @memberof CardDetailsReq
   */
  email: string
}
/**
 *
 * @export
 * @interface CardDetailsRes
 */
export interface CardDetailsRes {
  /**
   *
   * @type {string}
   * @memberof CardDetailsRes
   */
  requestId?: string
}
/**
 *
 * @export
 * @interface CardReferenceReq
 */
export interface CardReferenceReq {
  /**
   *
   * @type {string}
   * @memberof CardReferenceReq
   */
  lang: string
  /**
   *
   * @type {number}
   * @memberof CardReferenceReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof CardReferenceReq
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof CardReferenceReq
   */
  hashPAN: string
  /**
   *
   * @type {string}
   * @memberof CardReferenceReq
   */
  email?: string
}
/**
 *
 * @export
 * @interface CardReferenceRes
 */
export interface CardReferenceRes {
  /**
   *
   * @type {string}
   * @memberof CardReferenceRes
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof CardReferenceRes
   */
  file?: string
}
/**
 *
 * @export
 * @interface CardStatementReq
 */
export interface CardStatementReq {
  /**
   *
   * @type {string}
   * @memberof CardStatementReq
   */
  endDt: string
  /**
   *
   * @type {string}
   * @memberof CardStatementReq
   */
  email?: string
  /**
   *
   * @type {number}
   * @memberof CardStatementReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof CardStatementReq
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof CardStatementReq
   */
  startDt: string
  /**
   *
   * @type {string}
   * @memberof CardStatementReq
   */
  hashPAN: string
}
/**
 *
 * @export
 * @interface CardStatementRes
 */
export interface CardStatementRes {
  /**
   *
   * @type {string}
   * @memberof CardStatementRes
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof CardStatementRes
   */
  file?: string
}
/**
 *
 * @export
 * @interface CreditClosedReferenceReq
 */
export interface CreditClosedReferenceReq {
  /**
   *
   * @type {number}
   * @memberof CreditClosedReferenceReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof CreditClosedReferenceReq
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof CreditClosedReferenceReq
   */
  loanId: string
  /**
   *
   * @type {string}
   * @memberof CreditClosedReferenceReq
   */
  email?: string
}
/**
 *
 * @export
 * @interface CreditClosedReferenceRes
 */
export interface CreditClosedReferenceRes {
  /**
   *
   * @type {string}
   * @memberof CreditClosedReferenceRes
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof CreditClosedReferenceRes
   */
  file?: string
}
/**
 *
 * @export
 * @interface CreditCurrentReferenceReq
 */
export interface CreditCurrentReferenceReq {
  /**
   *
   * @type {number}
   * @memberof CreditCurrentReferenceReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof CreditCurrentReferenceReq
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof CreditCurrentReferenceReq
   */
  loanId: string
  /**
   *
   * @type {string}
   * @memberof CreditCurrentReferenceReq
   */
  email?: string
}
/**
 *
 * @export
 * @interface CreditCurrentReferenceRes
 */
export interface CreditCurrentReferenceRes {
  /**
   *
   * @type {string}
   * @memberof CreditCurrentReferenceRes
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof CreditCurrentReferenceRes
   */
  file?: string
}
/**
 *
 * @export
 * @interface CreditMonthlyPaymentsReq
 */
export interface CreditMonthlyPaymentsReq {
  /**
   *
   * @type {string}
   * @memberof CreditMonthlyPaymentsReq
   */
  endDt: string
  /**
   *
   * @type {string}
   * @memberof CreditMonthlyPaymentsReq
   */
  loanId: string
  /**
   *
   * @type {number}
   * @memberof CreditMonthlyPaymentsReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof CreditMonthlyPaymentsReq
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof CreditMonthlyPaymentsReq
   */
  startDt: string
  /**
   *
   * @type {string}
   * @memberof CreditMonthlyPaymentsReq
   */
  email?: string
}
/**
 *
 * @export
 * @interface CreditMonthlyPaymentsRes
 */
export interface CreditMonthlyPaymentsRes {
  /**
   *
   * @type {string}
   * @memberof CreditMonthlyPaymentsRes
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof CreditMonthlyPaymentsRes
   */
  file?: string
}
/**
 *
 * @export
 * @interface CustInfo
 */
export interface CustInfo {
  /**
   *
   * @type {string}
   * @memberof CustInfo
   */
  issue_date?: string
  /**
   *
   * @type {number}
   * @memberof CustInfo
   */
  passport_number?: number
  /**
   *
   * @type {string}
   * @memberof CustInfo
   */
  issue_org_name?: string
  /**
   *
   * @type {string}
   * @memberof CustInfo
   */
  birth_date?: string
  /**
   *
   * @type {string}
   * @memberof CustInfo
   */
  fio?: string
  /**
   *
   * @type {number}
   * @memberof CustInfo
   */
  passport_serial?: number
}
/**
 *
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
  /**
   *
   * @type {string}
   * @memberof ErrorResponse
   */
  requestId?: string
  /**
   *
   * @type {Error}
   * @memberof ErrorResponse
   */
  error?: Error
}
/**
 *
 * @export
 * @interface Field
 */
export interface Field {
  /**
   *
   * @type {string}
   * @memberof Field
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof Field
   */
  value?: string
}
/**
 *
 * @export
 * @interface GenPrintFormReq
 */
export interface GenPrintFormReq {
  /**
   *
   * @type {JsonNode}
   * @memberof GenPrintFormReq
   */
  data?: JsonNode
  /**
   *
   * @type {string}
   * @memberof GenPrintFormReq
   */
  docType?: string
  /**
   *
   * @type {string}
   * @memberof GenPrintFormReq
   */
  template?: string
}
/**
 *
 * @export
 * @interface GenPrintFormRes
 */
export interface GenPrintFormRes {
  /**
   *
   * @type {string}
   * @memberof GenPrintFormRes
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof GenPrintFormRes
   */
  file?: string
}
/**
 *
 * @export
 * @interface GenPrintFromServiceStatementReq
 */
export interface GenPrintFromServiceStatementReq {
  /**
   *
   * @type {CustInfo}
   * @memberof GenPrintFromServiceStatementReq
   */
  cust_info?: CustInfo
  /**
   *
   * @type {number}
   * @memberof GenPrintFromServiceStatementReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof GenPrintFromServiceStatementReq
   */
  tt_code?: string
  /**
   *
   * @type {Array<Field>}
   * @memberof GenPrintFromServiceStatementReq
   */
  field?: Array<Field>
  /**
   *
   * @type {ProductInfo}
   * @memberof GenPrintFromServiceStatementReq
   */
  product_info?: ProductInfo
  /**
   *
   * @type {string}
   * @memberof GenPrintFromServiceStatementReq
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof GenPrintFromServiceStatementReq
   */
  accepted_fio?: string
}
/**
 *
 * @export
 * @interface GenPrintFromServiceStatementRes
 */
export interface GenPrintFromServiceStatementRes {
  /**
   *
   * @type {string}
   * @memberof GenPrintFromServiceStatementRes
   */
  file_name?: string
  /**
   *
   * @type {string}
   * @memberof GenPrintFromServiceStatementRes
   */
  sp_name?: string
  /**
   *
   * @type {string}
   * @memberof GenPrintFromServiceStatementRes
   */
  file?: string
  /**
   *
   * @type {string}
   * @memberof GenPrintFromServiceStatementRes
   */
  request_id?: string
}
/**
 *
 * @export
 * @interface GracePeriodReq
 */
export interface GracePeriodReq {
  /**
   *
   * @type {number}
   * @memberof GracePeriodReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof GracePeriodReq
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof GracePeriodReq
   */
  endDate: string
  /**
   *
   * @type {string}
   * @memberof GracePeriodReq
   */
  hashPan: string
  /**
   *
   * @type {string}
   * @memberof GracePeriodReq
   */
  startDate: string
}
/**
 *
 * @export
 * @interface JsonNode
 */
export interface JsonNode {
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  containerNode?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  binary?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  bigInteger?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  _short?: boolean
  /**
   *
   * @type {string}
   * @memberof JsonNode
   */
  nodeType?: JsonNodeNodeTypeEnum
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  bigDecimal?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  integralNumber?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  _int?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  _double?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  valueNode?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  object?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  number?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  pojo?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  missingNode?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  _float?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  textual?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  _long?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  _boolean?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  array?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  _null?: boolean
  /**
   *
   * @type {boolean}
   * @memberof JsonNode
   */
  floatingPointNumber?: boolean
}

/**
 * @export
 * @enum {string}
 */
export enum JsonNodeNodeTypeEnum {
  ARRAY = 'ARRAY',
  BINARY = 'BINARY',
  BOOLEAN = 'BOOLEAN',
  MISSING = 'MISSING',
  NULL = 'NULL',
  NUMBER = 'NUMBER',
  OBJECT = 'OBJECT',
  POJO = 'POJO',
  STRING = 'STRING',
}

/**
 *
 * @export
 * @interface ModelError
 */
export interface ModelError {
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  message?: string
  /**
   *
   * @type {number}
   * @memberof ModelError
   */
  code?: number
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  uuid?: string
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  externalCode?: string
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  details?: string
}
/**
 *
 * @export
 * @interface PaymentReceiptReq
 */
export interface PaymentReceiptReq {
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptReq
   */
  listParams?: string
  /**
   *
   * @type {number}
   * @memberof PaymentReceiptReq
   */
  rboId?: number
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptReq
   */
  operationDetails?: string
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptReq
   */
  state?: string
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptReq
   */
  date?: string
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptReq
   */
  footerTitle?: string
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptReq
   */
  footerText?: string
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptReq
   */
  docName?: string
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptReq
   */
  srcPhone?: string
  /**
   *
   * @type {ReceiptPaymentTotal}
   * @memberof PaymentReceiptReq
   */
  total?: ReceiptPaymentTotal
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptReq
   */
  email?: string
}
/**
 *
 * @export
 * @interface PaymentReceiptRes
 */
export interface PaymentReceiptRes {
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptRes
   */
  base64String?: string
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptRes
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptRes
   */
  file?: string
  /**
   *
   * @type {string}
   * @memberof PaymentReceiptRes
   */
  fileName?: string
}
/**
 *
 * @export
 * @interface ProductInfo
 */
export interface ProductInfo {
  /**
   *
   * @type {string}
   * @memberof ProductInfo
   */
  account_repayment_debt?: string
  /**
   *
   * @type {string}
   * @memberof ProductInfo
   */
  number_loan_agreement?: string
}
/**
 *
 * @export
 * @interface ReceiptPaymentTotal
 */
export interface ReceiptPaymentTotal {
  /**
   *
   * @type {string}
   * @memberof ReceiptPaymentTotal
   */
  amount: string
  /**
   *
   * @type {string}
   * @memberof ReceiptPaymentTotal
   */
  curr: string
}

/**
 * DboPrintFormsApi - axios parameter creator
 * @export
 */
export const DboPrintFormsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Метод формирует и отправляет на почту письмо с реквизитами счета
     * @param {'v1'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {AccountDetailsReq} [accountDetailsReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountDetails(
      version: 'v1',
      rboId?: string,
      authorization?: string,
      accountDetailsReq?: AccountDetailsReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling accountDetails.'
        )
      }
      const localVarPath = `/dbo-print-forms/{version}/accountDetails`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (rboId !== undefined && rboId !== null) {
        localVarHeaderParameter['rbo_id'] = String(rboId)
      }

      if (authorization !== undefined && authorization !== null) {
        localVarHeaderParameter['authorization'] = String(authorization)
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof accountDetailsReq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(accountDetailsReq !== undefined ? accountDetailsReq : {})
        : accountDetailsReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary генерация справки о доступном остатке на счете на текущую дату
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {AccountReferenceReq} [accountReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      accountReferenceReq?: AccountReferenceReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling accountReference.'
        )
      }
      const localVarPath = `/dbo-print-forms/{version}/accountReference`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (rboId !== undefined && rboId !== null) {
        localVarHeaderParameter['rbo_id'] = String(rboId)
      }

      if (authorization !== undefined && authorization !== null) {
        localVarHeaderParameter['authorization'] = String(authorization)
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof accountReferenceReq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(accountReferenceReq !== undefined ? accountReferenceReq : {})
        : accountReferenceReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary генерация выписки по счету за выбранный период
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {AccountStatementReq} [accountStatementReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountStatement(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      accountStatementReq?: AccountStatementReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling accountStatement.'
        )
      }
      const localVarPath = `/dbo-print-forms/{version}/accountStatement`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (rboId !== undefined && rboId !== null) {
        localVarHeaderParameter['rbo_id'] = String(rboId)
      }

      if (authorization !== undefined && authorization !== null) {
        localVarHeaderParameter['authorization'] = String(authorization)
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof accountStatementReq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(accountStatementReq !== undefined ? accountStatementReq : {})
        : accountStatementReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Метод формирует и отправляет на почту письмо с реквизитами карты
     * @param {'v1'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CardDetailsReq} [cardDetailsReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cardDetails(
      version: 'v1',
      rboId?: string,
      authorization?: string,
      cardDetailsReq?: CardDetailsReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError('version', 'Required parameter version was null or undefined when calling cardDetails.')
      }
      const localVarPath = `/dbo-print-forms/{version}/cardDetails`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (rboId !== undefined && rboId !== null) {
        localVarHeaderParameter['rbo_id'] = String(rboId)
      }

      if (authorization !== undefined && authorization !== null) {
        localVarHeaderParameter['authorization'] = String(authorization)
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof cardDetailsReq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(cardDetailsReq !== undefined ? cardDetailsReq : {})
        : cardDetailsReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary генерирация справки о доступном остатке на карте на текущую дату
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CardReferenceReq} [cardReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cardReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      cardReferenceReq?: CardReferenceReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling cardReference.'
        )
      }
      const localVarPath = `/dbo-print-forms/{version}/cardReference`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (rboId !== undefined && rboId !== null) {
        localVarHeaderParameter['rbo_id'] = String(rboId)
      }

      if (authorization !== undefined && authorization !== null) {
        localVarHeaderParameter['authorization'] = String(authorization)
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof cardReferenceReq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(cardReferenceReq !== undefined ? cardReferenceReq : {})
        : cardReferenceReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary генерирация выписки по карте за указанный период и отправка на адрес электронной почты пользователя
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CardStatementReq} [cardStatementReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cardStatement(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      cardStatementReq?: CardStatementReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling cardStatement.'
        )
      }
      const localVarPath = `/dbo-print-forms/{version}/cardStatement`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (rboId !== undefined && rboId !== null) {
        localVarHeaderParameter['rbo_id'] = String(rboId)
      }

      if (authorization !== undefined && authorization !== null) {
        localVarHeaderParameter['authorization'] = String(authorization)
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof cardStatementReq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(cardStatementReq !== undefined ? cardStatementReq : {})
        : cardStatementReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary генерирует справку о полном погашении задолженности
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CreditClosedReferenceReq} [creditClosedReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditClosedReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      creditClosedReferenceReq?: CreditClosedReferenceReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling creditClosedReference.'
        )
      }
      const localVarPath = `/dbo-print-forms/{version}/creditClosedReference`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (rboId !== undefined && rboId !== null) {
        localVarHeaderParameter['rbo_id'] = String(rboId)
      }

      if (authorization !== undefined && authorization !== null) {
        localVarHeaderParameter['authorization'] = String(authorization)
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof creditClosedReferenceReq !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(creditClosedReferenceReq !== undefined ? creditClosedReferenceReq : {})
        : creditClosedReferenceReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary генерирует справку о текущей задолженности по кредиту
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CreditCurrentReferenceReq} [creditCurrentReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditCurrentReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      creditCurrentReferenceReq?: CreditCurrentReferenceReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling creditCurrentReference.'
        )
      }
      const localVarPath = `/dbo-print-forms/{version}/creditCurrentReference`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (rboId !== undefined && rboId !== null) {
        localVarHeaderParameter['rbo_id'] = String(rboId)
      }

      if (authorization !== undefined && authorization !== null) {
        localVarHeaderParameter['authorization'] = String(authorization)
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof creditCurrentReferenceReq !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(creditCurrentReferenceReq !== undefined ? creditCurrentReferenceReq : {})
        : creditCurrentReferenceReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Генерирует справку о ежемесячном осуществлении платежей в счет погашения основного долга и процентов по кредиту за выбранный период и затем отправляет ее на адрес электронной почты пользователя
     * @param {'v1' | 'v2'} version
     * @param {string} [clientId]
     * @param {string} [contentType]
     * @param {string} [platform]
     * @param {string} [appVersion]
     * @param {string} [requestId]
     * @param {string} [modelPhone]
     * @param {CreditMonthlyPaymentsReq} [creditMonthlyPaymentsReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditMonthlyPayments(
      version: 'v1' | 'v2',
      clientId?: string,
      contentType?: string,
      platform?: string,
      appVersion?: string,
      requestId?: string,
      modelPhone?: string,
      creditMonthlyPaymentsReq?: CreditMonthlyPaymentsReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling creditMonthlyPayments.'
        )
      }
      const localVarPath = `/dbo-print-forms/{version}/creditMonthlyPayments`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (clientId !== undefined && clientId !== null) {
        localVarHeaderParameter['Client-id'] = String(clientId)
      }

      if (contentType !== undefined && contentType !== null) {
        localVarHeaderParameter['Content-type'] = String(contentType)
      }

      if (platform !== undefined && platform !== null) {
        localVarHeaderParameter['Platform'] = String(platform)
      }

      if (appVersion !== undefined && appVersion !== null) {
        localVarHeaderParameter['App-version'] = String(appVersion)
      }

      if (requestId !== undefined && requestId !== null) {
        localVarHeaderParameter['Request-id'] = String(requestId)
      }

      if (modelPhone !== undefined && modelPhone !== null) {
        localVarHeaderParameter['Model-phone'] = String(modelPhone)
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof creditMonthlyPaymentsReq !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(creditMonthlyPaymentsReq !== undefined ? creditMonthlyPaymentsReq : {})
        : creditMonthlyPaymentsReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Генерирует печатную форму по шаблону с именем request.template и данными request.data
     * @param {'b' | 'anonymous'} zone
     * @param {'v1'} version
     * @param {GenPrintFormReq} [genPrintFormReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    genPrintForm(
      zone: 'b' | 'anonymous',
      version: 'v1',
      genPrintFormReq?: GenPrintFormReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'zone' is not null or undefined
      if (zone === null || zone === undefined) {
        throw new RequiredError('zone', 'Required parameter zone was null or undefined when calling genPrintForm.')
      }
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling genPrintForm.'
        )
      }
      const localVarPath = `/{zone}/dbo-print-forms/{version}/genPrintForm`
        .replace(`{${'zone'}}`, encodeURIComponent(String(zone)))
        .replace(`{${'version'}}`, encodeURIComponent(String(version)))
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof genPrintFormReq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(genPrintFormReq !== undefined ? genPrintFormReq : {})
        : genPrintFormReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Генерирует печатную форму по шаблону с именем request.template и данными request.data
     * @param {'b' | 'anonymous'} zone
     * @param {'v1'} version
     * @param {GenPrintFormReq} [genPrintFormReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    genPrintFormAuth(
      zone: 'b' | 'anonymous',
      version: 'v1',
      genPrintFormReq?: GenPrintFormReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'zone' is not null or undefined
      if (zone === null || zone === undefined) {
        throw new RequiredError('zone', 'Required parameter zone was null or undefined when calling genPrintFormAuth.')
      }
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling genPrintFormAuth.'
        )
      }
      const localVarPath = `/dbo-print-forms/{version}/genPrintForm`
        .replace(`{${'zone'}}`, encodeURIComponent(String(zone)))
        .replace(`{${'version'}}`, encodeURIComponent(String(version)))
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof genPrintFormReq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(genPrintFormReq !== undefined ? genPrintFormReq : {})
        : genPrintFormReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Выполняет поиск ПФ СЗ, автоматически заполняет найденную  ПФ СЗ данными по клиенту и продукту, а также генерирует и проставляет ШК и QR-код
     * @param {'v1'} version
     * @param {string} requestId
     * @param {string} typeCode
     * @param {string} spName
     * @param {string} [authorization]
     * @param {string} [custId]
     * @param {string} [sibelId]
     * @param {string} [rboId]
     * @param {GenPrintFromServiceStatementReq} [genPrintFromServiceStatementReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    genPrintFormServiceStatement(
      version: 'v1',
      requestId: string,
      typeCode: string,
      spName: string,
      authorization?: string,
      custId?: string,
      sibelId?: string,
      rboId?: string,
      genPrintFromServiceStatementReq?: GenPrintFromServiceStatementReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling genPrintFormServiceStatement.'
        )
      }
      // verify required parameter 'requestId' is not null or undefined
      if (requestId === null || requestId === undefined) {
        throw new RequiredError(
          'requestId',
          'Required parameter requestId was null or undefined when calling genPrintFormServiceStatement.'
        )
      }
      // verify required parameter 'typeCode' is not null or undefined
      if (typeCode === null || typeCode === undefined) {
        throw new RequiredError(
          'typeCode',
          'Required parameter typeCode was null or undefined when calling genPrintFormServiceStatement.'
        )
      }
      // verify required parameter 'spName' is not null or undefined
      if (spName === null || spName === undefined) {
        throw new RequiredError(
          'spName',
          'Required parameter spName was null or undefined when calling genPrintFormServiceStatement.'
        )
      }
      const localVarPath = `/dbo-print-forms/{version}/genPrintFormServiceStatement`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (authorization !== undefined && authorization !== null) {
        localVarHeaderParameter['authorization'] = String(authorization)
      }

      if (requestId !== undefined && requestId !== null) {
        localVarHeaderParameter['request_id'] = String(requestId)
      }

      if (typeCode !== undefined && typeCode !== null) {
        localVarHeaderParameter['type_code'] = String(typeCode)
      }

      if (custId !== undefined && custId !== null) {
        localVarHeaderParameter['cust_id'] = String(custId)
      }

      if (sibelId !== undefined && sibelId !== null) {
        localVarHeaderParameter['sibel_id'] = String(sibelId)
      }

      if (rboId !== undefined && rboId !== null) {
        localVarHeaderParameter['rbo_id'] = String(rboId)
      }

      if (spName !== undefined && spName !== null) {
        localVarHeaderParameter['sp_name'] = String(spName)
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof genPrintFromServiceStatementReq !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(genPrintFromServiceStatementReq !== undefined ? genPrintFromServiceStatementReq : {})
        : genPrintFromServiceStatementReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Выгрузка параметров перевода
     * @param {'v1' | 'v2' | 'v3'} version
     * @param {PaymentReceiptReq} [paymentReceiptReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransferDetails(
      version: 'v1' | 'v2' | 'v3',
      paymentReceiptReq?: PaymentReceiptReq,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling getTransferDetails.'
        )
      }
      const localVarPath = `/dbo-print-forms/{version}/paymentReceipt`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof paymentReceiptReq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(paymentReceiptReq !== undefined ? paymentReceiptReq : {})
        : paymentReceiptReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Справка по Льготному периоду и сумм мин.платежа
     * @param {'v1'} version
     * @param {GracePeriodReq} [gracePeriodReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gracePeriod(version: 'v1', gracePeriodReq?: GracePeriodReq, options: any = {}): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError('version', 'Required parameter version was null or undefined when calling gracePeriod.')
      }
      const localVarPath = `/dbo-print-forms/{version}/gracePeriod`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof gracePeriodReq !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(gracePeriodReq !== undefined ? gracePeriodReq : {})
        : gracePeriodReq || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {'v1'} version
     * @param {string} docId
     * @param {string} format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paydocform(version: 'v1', docId: string, format: string, options: any = {}): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError('version', 'Required parameter version was null or undefined when calling paydocform.')
      }
      // verify required parameter 'docId' is not null or undefined
      if (docId === null || docId === undefined) {
        throw new RequiredError('docId', 'Required parameter docId was null or undefined when calling paydocform.')
      }
      // verify required parameter 'format' is not null or undefined
      if (format === null || format === undefined) {
        throw new RequiredError('format', 'Required parameter format was null or undefined when calling paydocform.')
      }
      const localVarPath = `/dbo-print-forms/{version}/paydocform`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (docId !== undefined) {
        localVarQueryParameter['docId'] = docId
      }

      if (format !== undefined) {
        localVarQueryParameter['format'] = format
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * DboPrintFormsApi - functional programming interface
 * @export
 */
export const DboPrintFormsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Метод формирует и отправляет на почту письмо с реквизитами счета
     * @param {'v1'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {AccountDetailsReq} [accountDetailsReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountDetails(
      version: 'v1',
      rboId?: string,
      authorization?: string,
      accountDetailsReq?: AccountDetailsReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDetailsRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).accountDetails(
        version,
        rboId,
        authorization,
        accountDetailsReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary генерация справки о доступном остатке на счете на текущую дату
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {AccountReferenceReq} [accountReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      accountReferenceReq?: AccountReferenceReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountReferenceRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).accountReference(
        version,
        rboId,
        authorization,
        accountReferenceReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary генерация выписки по счету за выбранный период
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {AccountStatementReq} [accountStatementReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountStatement(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      accountStatementReq?: AccountStatementReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountStatementRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).accountStatement(
        version,
        rboId,
        authorization,
        accountStatementReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Метод формирует и отправляет на почту письмо с реквизитами карты
     * @param {'v1'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CardDetailsReq} [cardDetailsReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cardDetails(
      version: 'v1',
      rboId?: string,
      authorization?: string,
      cardDetailsReq?: CardDetailsReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardDetailsRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).cardDetails(
        version,
        rboId,
        authorization,
        cardDetailsReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary генерирация справки о доступном остатке на карте на текущую дату
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CardReferenceReq} [cardReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cardReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      cardReferenceReq?: CardReferenceReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardReferenceRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).cardReference(
        version,
        rboId,
        authorization,
        cardReferenceReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary генерирация выписки по карте за указанный период и отправка на адрес электронной почты пользователя
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CardStatementReq} [cardStatementReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cardStatement(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      cardStatementReq?: CardStatementReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardStatementRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).cardStatement(
        version,
        rboId,
        authorization,
        cardStatementReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary генерирует справку о полном погашении задолженности
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CreditClosedReferenceReq} [creditClosedReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditClosedReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      creditClosedReferenceReq?: CreditClosedReferenceReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditClosedReferenceRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).creditClosedReference(
        version,
        rboId,
        authorization,
        creditClosedReferenceReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary генерирует справку о текущей задолженности по кредиту
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CreditCurrentReferenceReq} [creditCurrentReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditCurrentReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      creditCurrentReferenceReq?: CreditCurrentReferenceReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditCurrentReferenceRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).creditCurrentReference(
        version,
        rboId,
        authorization,
        creditCurrentReferenceReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Генерирует справку о ежемесячном осуществлении платежей в счет погашения основного долга и процентов по кредиту за выбранный период и затем отправляет ее на адрес электронной почты пользователя
     * @param {'v1' | 'v2'} version
     * @param {string} [clientId]
     * @param {string} [contentType]
     * @param {string} [platform]
     * @param {string} [appVersion]
     * @param {string} [requestId]
     * @param {string} [modelPhone]
     * @param {CreditMonthlyPaymentsReq} [creditMonthlyPaymentsReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditMonthlyPayments(
      version: 'v1' | 'v2',
      clientId?: string,
      contentType?: string,
      platform?: string,
      appVersion?: string,
      requestId?: string,
      modelPhone?: string,
      creditMonthlyPaymentsReq?: CreditMonthlyPaymentsReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenPrintFromServiceStatementRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).creditMonthlyPayments(
        version,
        clientId,
        contentType,
        platform,
        appVersion,
        requestId,
        modelPhone,
        creditMonthlyPaymentsReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Генерирует печатную форму по шаблону с именем request.template и данными request.data
     * @param {'b' | 'anonymous'} zone
     * @param {'v1'} version
     * @param {GenPrintFormReq} [genPrintFormReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    genPrintForm(
      zone: 'b' | 'anonymous',
      version: 'v1',
      genPrintFormReq?: GenPrintFormReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenPrintFormRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).genPrintForm(
        zone,
        version,
        genPrintFormReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Генерирует печатную форму по шаблону с именем request.template и данными request.data
     * @param {'b' | 'anonymous'} zone
     * @param {'v1'} version
     * @param {GenPrintFormReq} [genPrintFormReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    genPrintFormAuth(
      zone: 'b' | 'anonymous',
      version: 'v1',
      genPrintFormReq?: GenPrintFormReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenPrintFormRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).genPrintFormAuth(
        zone,
        version,
        genPrintFormReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Выполняет поиск ПФ СЗ, автоматически заполняет найденную  ПФ СЗ данными по клиенту и продукту, а также генерирует и проставляет ШК и QR-код
     * @param {'v1'} version
     * @param {string} requestId
     * @param {string} typeCode
     * @param {string} spName
     * @param {string} [authorization]
     * @param {string} [custId]
     * @param {string} [sibelId]
     * @param {string} [rboId]
     * @param {GenPrintFromServiceStatementReq} [genPrintFromServiceStatementReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    genPrintFormServiceStatement(
      version: 'v1',
      requestId: string,
      typeCode: string,
      spName: string,
      authorization?: string,
      custId?: string,
      sibelId?: string,
      rboId?: string,
      genPrintFromServiceStatementReq?: GenPrintFromServiceStatementReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditMonthlyPaymentsRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).genPrintFormServiceStatement(
        version,
        requestId,
        typeCode,
        spName,
        authorization,
        custId,
        sibelId,
        rboId,
        genPrintFromServiceStatementReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Выгрузка параметров перевода
     * @param {'v1' | 'v2' | 'v3'} version
     * @param {PaymentReceiptReq} [paymentReceiptReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransferDetails(
      version: 'v1' | 'v2' | 'v3',
      paymentReceiptReq?: PaymentReceiptReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentReceiptRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).getTransferDetails(
        version,
        paymentReceiptReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Справка по Льготному периоду и сумм мин.платежа
     * @param {'v1'} version
     * @param {GracePeriodReq} [gracePeriodReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gracePeriod(
      version: 'v1',
      gracePeriodReq?: GracePeriodReq,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditCurrentReferenceRes> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).gracePeriod(
        version,
        gracePeriodReq,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {'v1'} version
     * @param {string} docId
     * @param {string} format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paydocform(
      version: 'v1',
      docId: string,
      format: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse> {
      const localVarAxiosArgs = DboPrintFormsApiAxiosParamCreator(configuration).paydocform(
        version,
        docId,
        format,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * DboPrintFormsApi - factory interface
 * @export
 */
export const DboPrintFormsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Метод формирует и отправляет на почту письмо с реквизитами счета
     * @param {'v1'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {AccountDetailsReq} [accountDetailsReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountDetails(
      version: 'v1',
      rboId?: string,
      authorization?: string,
      accountDetailsReq?: AccountDetailsReq,
      options?: any
    ): AxiosPromise<AccountDetailsRes> {
      return DboPrintFormsApiFp(configuration).accountDetails(
        version,
        rboId,
        authorization,
        accountDetailsReq,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary генерация справки о доступном остатке на счете на текущую дату
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {AccountReferenceReq} [accountReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      accountReferenceReq?: AccountReferenceReq,
      options?: any
    ): AxiosPromise<AccountReferenceRes> {
      return DboPrintFormsApiFp(configuration).accountReference(
        version,
        rboId,
        authorization,
        accountReferenceReq,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary генерация выписки по счету за выбранный период
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {AccountStatementReq} [accountStatementReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountStatement(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      accountStatementReq?: AccountStatementReq,
      options?: any
    ): AxiosPromise<AccountStatementRes> {
      return DboPrintFormsApiFp(configuration).accountStatement(
        version,
        rboId,
        authorization,
        accountStatementReq,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary Метод формирует и отправляет на почту письмо с реквизитами карты
     * @param {'v1'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CardDetailsReq} [cardDetailsReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cardDetails(
      version: 'v1',
      rboId?: string,
      authorization?: string,
      cardDetailsReq?: CardDetailsReq,
      options?: any
    ): AxiosPromise<CardDetailsRes> {
      return DboPrintFormsApiFp(configuration).cardDetails(
        version,
        rboId,
        authorization,
        cardDetailsReq,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary генерирация справки о доступном остатке на карте на текущую дату
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CardReferenceReq} [cardReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cardReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      cardReferenceReq?: CardReferenceReq,
      options?: any
    ): AxiosPromise<CardReferenceRes> {
      return DboPrintFormsApiFp(configuration).cardReference(
        version,
        rboId,
        authorization,
        cardReferenceReq,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary генерирация выписки по карте за указанный период и отправка на адрес электронной почты пользователя
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CardStatementReq} [cardStatementReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cardStatement(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      cardStatementReq?: CardStatementReq,
      options?: any
    ): AxiosPromise<CardStatementRes> {
      return DboPrintFormsApiFp(configuration).cardStatement(
        version,
        rboId,
        authorization,
        cardStatementReq,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary генерирует справку о полном погашении задолженности
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CreditClosedReferenceReq} [creditClosedReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditClosedReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      creditClosedReferenceReq?: CreditClosedReferenceReq,
      options?: any
    ): AxiosPromise<CreditClosedReferenceRes> {
      return DboPrintFormsApiFp(configuration).creditClosedReference(
        version,
        rboId,
        authorization,
        creditClosedReferenceReq,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary генерирует справку о текущей задолженности по кредиту
     * @param {'v1' | 'v2'} version
     * @param {string} [rboId]
     * @param {string} [authorization]
     * @param {CreditCurrentReferenceReq} [creditCurrentReferenceReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditCurrentReference(
      version: 'v1' | 'v2',
      rboId?: string,
      authorization?: string,
      creditCurrentReferenceReq?: CreditCurrentReferenceReq,
      options?: any
    ): AxiosPromise<CreditCurrentReferenceRes> {
      return DboPrintFormsApiFp(configuration).creditCurrentReference(
        version,
        rboId,
        authorization,
        creditCurrentReferenceReq,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary Генерирует справку о ежемесячном осуществлении платежей в счет погашения основного долга и процентов по кредиту за выбранный период и затем отправляет ее на адрес электронной почты пользователя
     * @param {'v1' | 'v2'} version
     * @param {string} [clientId]
     * @param {string} [contentType]
     * @param {string} [platform]
     * @param {string} [appVersion]
     * @param {string} [requestId]
     * @param {string} [modelPhone]
     * @param {CreditMonthlyPaymentsReq} [creditMonthlyPaymentsReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditMonthlyPayments(
      version: 'v1' | 'v2',
      clientId?: string,
      contentType?: string,
      platform?: string,
      appVersion?: string,
      requestId?: string,
      modelPhone?: string,
      creditMonthlyPaymentsReq?: CreditMonthlyPaymentsReq,
      options?: any
    ): AxiosPromise<GenPrintFromServiceStatementRes> {
      return DboPrintFormsApiFp(configuration).creditMonthlyPayments(
        version,
        clientId,
        contentType,
        platform,
        appVersion,
        requestId,
        modelPhone,
        creditMonthlyPaymentsReq,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary Генерирует печатную форму по шаблону с именем request.template и данными request.data
     * @param {'b' | 'anonymous'} zone
     * @param {'v1'} version
     * @param {GenPrintFormReq} [genPrintFormReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    genPrintForm(
      zone: 'b' | 'anonymous',
      version: 'v1',
      genPrintFormReq?: GenPrintFormReq,
      options?: any
    ): AxiosPromise<GenPrintFormRes> {
      return DboPrintFormsApiFp(configuration).genPrintForm(zone, version, genPrintFormReq, options)(axios, basePath)
    },
    /**
     *
     * @summary Генерирует печатную форму по шаблону с именем request.template и данными request.data
     * @param {'b' | 'anonymous'} zone
     * @param {'v1'} version
     * @param {GenPrintFormReq} [genPrintFormReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    genPrintFormAuth(
      zone: 'b' | 'anonymous',
      version: 'v1',
      genPrintFormReq?: GenPrintFormReq,
      options?: any
    ): AxiosPromise<GenPrintFormRes> {
      return DboPrintFormsApiFp(configuration).genPrintFormAuth(
        zone,
        version,
        genPrintFormReq,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary Выполняет поиск ПФ СЗ, автоматически заполняет найденную  ПФ СЗ данными по клиенту и продукту, а также генерирует и проставляет ШК и QR-код
     * @param {'v1'} version
     * @param {string} requestId
     * @param {string} typeCode
     * @param {string} spName
     * @param {string} [authorization]
     * @param {string} [custId]
     * @param {string} [sibelId]
     * @param {string} [rboId]
     * @param {GenPrintFromServiceStatementReq} [genPrintFromServiceStatementReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    genPrintFormServiceStatement(
      version: 'v1',
      requestId: string,
      typeCode: string,
      spName: string,
      authorization?: string,
      custId?: string,
      sibelId?: string,
      rboId?: string,
      genPrintFromServiceStatementReq?: GenPrintFromServiceStatementReq,
      options?: any
    ): AxiosPromise<CreditMonthlyPaymentsRes> {
      return DboPrintFormsApiFp(configuration).genPrintFormServiceStatement(
        version,
        requestId,
        typeCode,
        spName,
        authorization,
        custId,
        sibelId,
        rboId,
        genPrintFromServiceStatementReq,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary Выгрузка параметров перевода
     * @param {'v1' | 'v2' | 'v3'} version
     * @param {PaymentReceiptReq} [paymentReceiptReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransferDetails(
      version: 'v1' | 'v2' | 'v3',
      paymentReceiptReq?: PaymentReceiptReq,
      options?: any
    ): AxiosPromise<PaymentReceiptRes> {
      return DboPrintFormsApiFp(configuration).getTransferDetails(version, paymentReceiptReq, options)(axios, basePath)
    },
    /**
     *
     * @summary Справка по Льготному периоду и сумм мин.платежа
     * @param {'v1'} version
     * @param {GracePeriodReq} [gracePeriodReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gracePeriod(
      version: 'v1',
      gracePeriodReq?: GracePeriodReq,
      options?: any
    ): AxiosPromise<CreditCurrentReferenceRes> {
      return DboPrintFormsApiFp(configuration).gracePeriod(version, gracePeriodReq, options)(axios, basePath)
    },
    /**
     *
     * @param {'v1'} version
     * @param {string} docId
     * @param {string} format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paydocform(version: 'v1', docId: string, format: string, options?: any): AxiosPromise<BaseResponse> {
      return DboPrintFormsApiFp(configuration).paydocform(version, docId, format, options)(axios, basePath)
    },
  }
}

/**
 * DboPrintFormsApi - object-oriented interface
 * @export
 * @class DboPrintFormsApi
 * @extends {BaseAPI}
 */
export class DboPrintFormsApi extends BaseAPI {
  /**
   *
   * @summary Метод формирует и отправляет на почту письмо с реквизитами счета
   * @param {'v1'} version
   * @param {string} [rboId]
   * @param {string} [authorization]
   * @param {AccountDetailsReq} [accountDetailsReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public accountDetails(
    version: 'v1',
    rboId?: string,
    authorization?: string,
    accountDetailsReq?: AccountDetailsReq,
    options?: any
  ) {
    return DboPrintFormsApiFp(this.configuration).accountDetails(
      version,
      rboId,
      authorization,
      accountDetailsReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary генерация справки о доступном остатке на счете на текущую дату
   * @param {'v1' | 'v2'} version
   * @param {string} [rboId]
   * @param {string} [authorization]
   * @param {AccountReferenceReq} [accountReferenceReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public accountReference(
    version: 'v1' | 'v2',
    rboId?: string,
    authorization?: string,
    accountReferenceReq?: AccountReferenceReq,
    options?: any
  ) {
    return DboPrintFormsApiFp(this.configuration).accountReference(
      version,
      rboId,
      authorization,
      accountReferenceReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary генерация выписки по счету за выбранный период
   * @param {'v1' | 'v2'} version
   * @param {string} [rboId]
   * @param {string} [authorization]
   * @param {AccountStatementReq} [accountStatementReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public accountStatement(
    version: 'v1' | 'v2',
    rboId?: string,
    authorization?: string,
    accountStatementReq?: AccountStatementReq,
    options?: any
  ) {
    return DboPrintFormsApiFp(this.configuration).accountStatement(
      version,
      rboId,
      authorization,
      accountStatementReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary Метод формирует и отправляет на почту письмо с реквизитами карты
   * @param {'v1'} version
   * @param {string} [rboId]
   * @param {string} [authorization]
   * @param {CardDetailsReq} [cardDetailsReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public cardDetails(
    version: 'v1',
    rboId?: string,
    authorization?: string,
    cardDetailsReq?: CardDetailsReq,
    options?: any
  ) {
    return DboPrintFormsApiFp(this.configuration).cardDetails(
      version,
      rboId,
      authorization,
      cardDetailsReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary генерирация справки о доступном остатке на карте на текущую дату
   * @param {'v1' | 'v2'} version
   * @param {string} [rboId]
   * @param {string} [authorization]
   * @param {CardReferenceReq} [cardReferenceReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public cardReference(
    version: 'v1' | 'v2',
    rboId?: string,
    authorization?: string,
    cardReferenceReq?: CardReferenceReq,
    options?: any
  ) {
    return DboPrintFormsApiFp(this.configuration).cardReference(
      version,
      rboId,
      authorization,
      cardReferenceReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary генерирация выписки по карте за указанный период и отправка на адрес электронной почты пользователя
   * @param {'v1' | 'v2'} version
   * @param {string} [rboId]
   * @param {string} [authorization]
   * @param {CardStatementReq} [cardStatementReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public cardStatement(
    version: 'v1' | 'v2',
    rboId?: string,
    authorization?: string,
    cardStatementReq?: CardStatementReq,
    options?: any
  ) {
    return DboPrintFormsApiFp(this.configuration).cardStatement(
      version,
      rboId,
      authorization,
      cardStatementReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary генерирует справку о полном погашении задолженности
   * @param {'v1' | 'v2'} version
   * @param {string} [rboId]
   * @param {string} [authorization]
   * @param {CreditClosedReferenceReq} [creditClosedReferenceReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public creditClosedReference(
    version: 'v1' | 'v2',
    rboId?: string,
    authorization?: string,
    creditClosedReferenceReq?: CreditClosedReferenceReq,
    options?: any
  ) {
    return DboPrintFormsApiFp(this.configuration).creditClosedReference(
      version,
      rboId,
      authorization,
      creditClosedReferenceReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary генерирует справку о текущей задолженности по кредиту
   * @param {'v1' | 'v2'} version
   * @param {string} [rboId]
   * @param {string} [authorization]
   * @param {CreditCurrentReferenceReq} [creditCurrentReferenceReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public creditCurrentReference(
    version: 'v1' | 'v2',
    rboId?: string,
    authorization?: string,
    creditCurrentReferenceReq?: CreditCurrentReferenceReq,
    options?: any
  ) {
    return DboPrintFormsApiFp(this.configuration).creditCurrentReference(
      version,
      rboId,
      authorization,
      creditCurrentReferenceReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary Генерирует справку о ежемесячном осуществлении платежей в счет погашения основного долга и процентов по кредиту за выбранный период и затем отправляет ее на адрес электронной почты пользователя
   * @param {'v1' | 'v2'} version
   * @param {string} [clientId]
   * @param {string} [contentType]
   * @param {string} [platform]
   * @param {string} [appVersion]
   * @param {string} [requestId]
   * @param {string} [modelPhone]
   * @param {CreditMonthlyPaymentsReq} [creditMonthlyPaymentsReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public creditMonthlyPayments(
    version: 'v1' | 'v2',
    clientId?: string,
    contentType?: string,
    platform?: string,
    appVersion?: string,
    requestId?: string,
    modelPhone?: string,
    creditMonthlyPaymentsReq?: CreditMonthlyPaymentsReq,
    options?: any
  ) {
    return DboPrintFormsApiFp(this.configuration).creditMonthlyPayments(
      version,
      clientId,
      contentType,
      platform,
      appVersion,
      requestId,
      modelPhone,
      creditMonthlyPaymentsReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary Генерирует печатную форму по шаблону с именем request.template и данными request.data
   * @param {'b' | 'anonymous'} zone
   * @param {'v1'} version
   * @param {GenPrintFormReq} [genPrintFormReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public genPrintForm(zone: 'b' | 'anonymous', version: 'v1', genPrintFormReq?: GenPrintFormReq, options?: any) {
    return DboPrintFormsApiFp(this.configuration).genPrintForm(
      zone,
      version,
      genPrintFormReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary Генерирует печатную форму по шаблону с именем request.template и данными request.data
   * @param {'b' | 'anonymous'} zone
   * @param {'v1'} version
   * @param {GenPrintFormReq} [genPrintFormReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public genPrintFormAuth(zone: 'b' | 'anonymous', version: 'v1', genPrintFormReq?: GenPrintFormReq, options?: any) {
    return DboPrintFormsApiFp(this.configuration).genPrintFormAuth(
      zone,
      version,
      genPrintFormReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary Выполняет поиск ПФ СЗ, автоматически заполняет найденную  ПФ СЗ данными по клиенту и продукту, а также генерирует и проставляет ШК и QR-код
   * @param {'v1'} version
   * @param {string} requestId
   * @param {string} typeCode
   * @param {string} spName
   * @param {string} [authorization]
   * @param {string} [custId]
   * @param {string} [sibelId]
   * @param {string} [rboId]
   * @param {GenPrintFromServiceStatementReq} [genPrintFromServiceStatementReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public genPrintFormServiceStatement(
    version: 'v1',
    requestId: string,
    typeCode: string,
    spName: string,
    authorization?: string,
    custId?: string,
    sibelId?: string,
    rboId?: string,
    genPrintFromServiceStatementReq?: GenPrintFromServiceStatementReq,
    options?: any
  ) {
    return DboPrintFormsApiFp(this.configuration).genPrintFormServiceStatement(
      version,
      requestId,
      typeCode,
      spName,
      authorization,
      custId,
      sibelId,
      rboId,
      genPrintFromServiceStatementReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary Выгрузка параметров перевода
   * @param {'v1' | 'v2' | 'v3'} version
   * @param {PaymentReceiptReq} [paymentReceiptReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public getTransferDetails(version: 'v1' | 'v2' | 'v3', paymentReceiptReq?: PaymentReceiptReq, options?: any) {
    return DboPrintFormsApiFp(this.configuration).getTransferDetails(
      version,
      paymentReceiptReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary Справка по Льготному периоду и сумм мин.платежа
   * @param {'v1'} version
   * @param {GracePeriodReq} [gracePeriodReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public gracePeriod(version: 'v1', gracePeriodReq?: GracePeriodReq, options?: any) {
    return DboPrintFormsApiFp(this.configuration).gracePeriod(
      version,
      gracePeriodReq,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @param {'v1'} version
   * @param {string} docId
   * @param {string} format
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DboPrintFormsApi
   */
  public paydocform(version: 'v1', docId: string, format: string, options?: any) {
    return DboPrintFormsApiFp(this.configuration).paydocform(version, docId, format, options)(this.axios, this.basePath)
  }
}
